<template>
  <div>
    <notifications />
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  computed: {
    isLoggedIn: function () {
      return this.$store.getters['account/isLoggedIn'];
    }
  },
  methods: {
    logout: function () {
      this.$store.dispatch('account/logout')
              .then(() => {});
    }
  }
}
</script>

<!--
<style>
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/css/font-awesome.min.css';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/css/simple-line-icons.css';
  /* Import Bootstrap Vue Styles */
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
</style>
<style lang="scss">
  // Import Main styles for this application
  @import './scss/style';
</style>
-->